if (!customElements.get('product-card')) {
  customElements.define('product-card', class ProductCard extends HTMLElement {
    constructor() {
      super()

      this.gravitationalLink = this.querySelector('.gravitational-link')
      this.media = this.querySelector('.media')
      this.gravitationalLink.addEventListener('mouseover', this.slightlyZoomInMedia.bind(this))
      this.gravitationalLink.addEventListener('mouseleave', this.backToNormalZoomMedia.bind(this))

      this.mainImage = this.querySelector(`#card-product-${ this.dataset.productId }_main-image`)

      if (this.dataset.showSecondary) {
        this.secondaryImage = this.querySelector(`#card-product-${ this.dataset.productId }_secondary-image`)
        this.gravitationalLink.addEventListener(
          'mouseover', this.switchFromMainImageToSecondary.bind(this))
        this.gravitationalLink.addEventListener(
          'mouseleave', this.switchFromSecondaryImageToMain.bind(this))
          
        this.addEventListener('mouseleave', this.switchFromSecondaryImageToMain.bind(this))
      }

      if (this.dataset.hasColor) {
        this.productImages = this.querySelectorAll('.card-product_product-image')
        this.variantSelectors = this.querySelectorAll('.card-color-variants__selector')
        this.variantSelectors.forEach(varSelector => {
          varSelector.addEventListener('mouseover', () => {
            this.productImages.forEach(image => {
              if (image.id == `${varSelector.dataset.targetImageId}`) {
                image.classList.add('card-product_product-image--visible');
              } else {
                image.classList.remove('card-product_product-image--visible');
              }
            })
          })
          varSelector.addEventListener('mouseover', this.slightlyZoomInMedia.bind(this))

          varSelector.addEventListener('mouseleave', () => {
            this.productImages.forEach(image => {
              image.classList.remove('card-product_product-image--visible');
            })
            if (this.dataset.showSecondary) {
              this.secondaryImage.classList.add('card-product_product-image--visible');
            } else {
              this.mainImage.classList.add('card-product_product-image--visible');
            }
          })
        })
      }

      this.addEventListener('mouseleave', this.backToNormalZoomMedia.bind(this))
    }

    slightlyZoomInMedia() {
      this.media.classList.add('media--zoomed')
    }

    backToNormalZoomMedia() {
      this.media.classList.remove('media--zoomed')
    }

    switchFromMainImageToSecondary() {
      this.mainImage.classList.remove('card-product_product-image--visible');
      this.secondaryImage.classList.add('card-product_product-image--visible');
    }

    switchFromSecondaryImageToMain() {
      this.mainImage.classList.add('card-product_product-image--visible');
      this.secondaryImage.classList.remove('card-product_product-image--visible');
    }
  })
}
